'use client';

import { useSession } from 'next-auth/react';
import DashboardClient from './dashbard-client';
import { Session } from 'next-auth';
import { useEffect, useRef } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { LoaderIcon } from 'lucide-react';
import MouseTracker from '@/lib/mouse-tracker-utils';

export default function Home({
	initialDomain,
	initialGoal,
	initialSession,
	useRealLeads
}: {
	initialDomain: string | null;
	initialGoal: string | null;
	initialSession: Session | null;
	useRealLeads: boolean | null;
}) {
	const { data: session, status } = useSession();

	const sessionRef = useRef<Session | null>(initialSession);

	useEffect(() => {
		if (!session) {
			console.log('Waiting for session', {
				session,
				status
			});
			return;
		}
		if (session && sessionRef.current?.siteId !== session?.siteId) {
			console.log('Session updated', {
				session
			});
			sessionRef.current = session;
		}
	}, [session, status]);

	if (!sessionRef.current || !sessionRef.current.siteId) {
		return (
			<div
				className="w-full lg:max-w-none max-w-4xl mx-auto overflow-hidden bg-gradient-to-br"
				id="get-started"
			>
				<section className="w-full py-10 bg-gradient-to-r from-[#01beb7] to-[#33e66c]">
					<div className="container mx-auto px-4">
						<div className="max-w-3xl mx-auto">
							<div className="bg-white/10 backdrop-blur-lg rounded-lg p-6 space-y-6">
								<div className="space-y-4">
									<h2 className="text-2xl font-bold text-white">
										What Products or Services do you want to outreach about?
									</h2>
									<Input
										name="productInfo"
										placeholder="Enter your website URL"
										value={''}
										disabled={true}
										type="url"
										className="bg-white/90 text-gray-900 placeholder:text-gray-500"
									/>
									<Button
										className="w-full bg-white text-gray-900 hover:bg-white/90"
										disabled={true}
									>
										Starting...
										<LoaderIcon className="h-4 w-4 ml-2 animate-spin" />
									</Button>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}

	return (
		<>
			<MouseTracker endpoint="/api/mouse" interval={10000} />
			<DashboardClient
				domainParam={initialDomain}
				goalParam={initialGoal}
				siteId={sessionRef.current.siteId}
				session={sessionRef.current}
				useRealLeads={useRealLeads}
			/>
		</>
	);
}
